
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { ReactElement } from 'react'
import { MediaFeed } from '@jconradi/tutu-porn-components/components/Media/MediaFeed/MediaFeed'
import { useRouter } from 'next/router'
import { WatchContextProvider } from '@jconradi/tutu-porn-components/contexts/WatchContext'
import { getFeaturedTutuVideos, TutuModelVideo } from '@jconradi/tutu-porn-components/services/api/tutu-models/tutu-models'
import { shuffleArray } from '@jconradi/tutu-porn-components/util/random'
import { getLayout } from '../components/Layout/Layout'

export interface BrowseProps {
    tutuAds: TutuModelVideo[];
}
export default function Browse({ tutuAds }: BrowseProps) {
    const router = useRouter();

    return (
        <section className='flex flex-col w-full gap-y-8 mb-8'>
            <MediaFeed tutuAds={tutuAds} loading={router.isReady} />
        </section>
    )
}

Browse.getLayout = (page: ReactElement) => <WatchContextProvider>{getLayout(page)}</WatchContextProvider>


 async function _getStaticProps({ locale }: any) {
  
  const featuredVideos = await getFeaturedTutuVideos();
  const shuffledFeaturedVideos = shuffleArray(featuredVideos);

    return {
      props: {
        tutuAds: shuffledFeaturedVideos
      },
      revalidate: 60
    }
  }

// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/browse',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  